import client from "shared/setupClient";
import { loader } from "graphql.macro";
import {setChecklists, setCurrentState, setLoading} from "./index";
const fetchChecklistsQuery = loader("graphql/queries/checklist/fetchChecklists.graphql");

export default function fetchChecklistsAction(organisationId, t) {
    return (dispatch) => {
        return client.query({query: fetchChecklistsQuery, variables: {organisationId}})
            .then((response) => {

                const {data} = response;
                const {checklists} = data;
                const newChecklists = [...checklists];
                newChecklists.unshift({id: null, label: t("none"), selected: true});
                dispatch(setChecklists(newChecklists));
                dispatch(setCurrentState(1));
                dispatch(setLoading(false));
            });
    };
}
